<app-modal
  (isClosing)="modalClosing.emit(true)"
  (isDismissing)="modalClosing.emit(true)"
  *ngIf="showModal"
  #modal
  [modalConfig]="{
    customFooter: true,
    titleText: 'Filter Results',
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    openOnLoad: true,
    options: {
      size: 'md',
    },
  }">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="modal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>

  <div class="container">
    <div class="row">
      <div *ngIf="canFilterByDistrict" class="form-group">
        <h5>District(s):</h5>
        <app-district-multi-select
          (selectedDistrictList)="updateDistricts($event)"
          [defaultDistricts]="
            editedFilters.districtFilter ? editedFilters.districtFilter : null
          "></app-district-multi-select>
      </div>

      <div *ngIf="reportName !== 'badge_progress'" class="form-group mt-3">
        <div class="form-group mt-3">
          <h5>School Year:</h5>
          <!-- Multi School Year Select -->
          <ng-container
            *ngIf="
              reportName === 'badges_earned_growth';
              else singleYearSelect
            ">
            <app-year-select
              [isMulti]="true"
              [clearAfterSelection]="true"
              [defaultYears]="editedFilters.schoolYearsFilter || null"
              (selectedYearList)="updateSchoolYears($event)"></app-year-select>
          </ng-container>
          <!-- Single School Year Select -->
          <ng-template #singleYearSelect>
            <app-year-select
              [defaultYear]="editedFilters.schoolYearFilter || null"
              (selectedYear)="updateSchoolYear($event)"></app-year-select>
          </ng-template>
        </div>
      </div>
      <div class="form-group mt-3" *ngIf="editedFilters.proFormFilter">
        <h5>Filter by form answers</h5>
        <app-form-answer-select
          [answers]="proFormAnswers"
          [defaultAnswers]="initialFilters.formAnswersFilter || []"
          (selectedAnswerList)="updateFormAnswers($event)">
        </app-form-answer-select>
      </div>
      <div *ngIf="districtsComponentValue.length > 0">
        <div
          *ngIf="
            reportName === 'badge_progress' ||
            reportName === 'evidence_report' ||
            reportName === 'badges_earned_growth'
          "
          class="form-group mt-3">
          <h5>Topic:</h5>
          <app-topic-select
            [label]="'Topic'"
            [defaultTopic]="editedFilters.topicFilter || null"
            [topics]="topics"
            [districtIds]="districtsComponentValue"
            [placeholder]="'Search for a topic...'"
            (selectedTopic)="updateTopic($event)"></app-topic-select>
        </div>
        <div
          *ngIf="
            !isAnonymous &&
            reportName !== 'implementationPlan' &&
            (!editedFilters.districtFilter ||
              editedFilters.districtFilter.length < 2)
          "
          class="form-group mt-3">
          <h5>School:</h5>
          <app-school-select
            [defaultSchools]="editedFilters.schoolFilter || null"
            [assignedCoacheesSchoolsOnly]="!canSeeAllSchools"
            [districtId]="districtsComponentValue"
            [isMulti]="true"
            (selectedSchoolList)="updateSchools($event)">
          </app-school-select>
        </div>

        <ng-container
          *ngIf="
            reportName === 'report_dashboard' ||
            reportName === 'support_insights' ||
            reportName === 'observation_reports' ||
            reportName === 'session_details'
          ">
          <div class="form-group mt-3">
            <h5>Session Owner</h5>
            <app-user-select
              [clearAfterSelection]="true"
              [districtIds]="districtsComponentValue"
              (selectedUser)="addSessionOwner($event)"></app-user-select>
          </div>
        </ng-container>

        <div class="form-group mt-3">
          <ng-container *ngFor="let sessionOwner of currentSessionOwners">
            <div class="d-flex align-items-center col-6 my-1">
              <app-avatar
                [profile]="sessionOwner.profile"
                [avatarSize]="'small'"></app-avatar>
              <span class="ms-2">
                {{ sessionOwner.profile.first_name }}
                {{ sessionOwner.profile.last_name }}
              </span>
              <button
                (click)="removeSessionOwner(sessionOwner)"
                aria-label="Remove session owner button"
                class="btn btn-delete btn-sm"
                type="button"
                ngbTooltip="Remove Session Owner">
                <i class="bi bi-x-circle-fill"></i>
              </button>
            </div>
          </ng-container>
        </div>

        <div
          *ngIf="
            !isAnonymous &&
            (!editedFilters.districtFilter ||
              editedFilters.districtFilter.length < 2)
          "
          class="form-group mt-3">
          <h5>Cohort:</h5>
          <app-cohort-select
            [isMulti]="true"
            [districtIds]="districtsComponentValue"
            [defaultCohorts]="
              editedFilters.cohortFilter ? editedFilters.cohortFilter : null
            "
            (selectedCohortList)="updateCohort($event)"></app-cohort-select>
        </div>
        <div
          class="form-group mt-3"
          *ngIf="
            reportName !== 'proforms_reports' &&
            reportName !== 'implementationPlan' &&
            (!editedFilters.districtFilter ||
              editedFilters.districtFilter.length < 2)
          ">
          <h5>Assigned Coach:</h5>
          <app-coach-select
            [defaultCoaches]="
              editedFilters.assignedCoachFilter
                ? [editedFilters.assignedCoachFilter]
                : null
            "
            (selectedCoach)="updateCoach($event)"
            [districtIds]="districtsComponentValue"></app-coach-select>
        </div>
        <div
          *ngIf="
            reportName === 'session_details' ||
            reportName === 'observation_reports'
          "
          class="form-group mt-3">
          <h5>Coachee(s):</h5>
          <app-user-select
            [clearAfterSelection]="false"
            [isMulti]="true"
            [defaultUsers]="
              editedFilters.coacheesFilter ? editedFilters.coacheesFilter : null
            "
            (selectedUserList)="updateCoachees($event)" />
        </div>
        <div
          *ngIf="reportName === 'implementationPlan'"
          class="form-group mt-3">
          <h5>Plan User(s):</h5>
          <app-user-select
            [clearAfterSelection]="false"
            [isMulti]="true"
            [defaultUsers]="
              editedFilters.planUserFilter ? editedFilters.planUserFilter : null
            "
            (selectedUserList)="updatePlanUsers($event)" />
        </div>
        <div
          class="form-group mt-3"
          *ngIf="
            reportName === 'support_insights' ||
            reportName === 'session_details'
          ">
          <h5>Session Type:</h5>
          <app-log-type-select
            [isMulti]="true"
            [districtId]="districtsComponentValue"
            [defaultLogTypes]="editedFilters.logTypeFilter || null"
            (selectedLogTypeList)="updateLogTypes($event)" />
        </div>

        <ng-container *ngIf="reportName === 'pd_session_summary'">
          <div class="form-group mt-3">
            <h5>Keyword:</h5>
            <input
              [(ngModel)]="editedFilters.keyword"
              type="text"
              class="form-control" />
          </div>
        </ng-container>

        <ng-container
          *ngIf="
            reportName === 'pd_session_summary' ||
            reportName === 'proforms_reports'
          ">
          <div class="form-group mt-3">
            <h5>Event:</h5>
            <app-pd-event-select
              [defaultEvents]="editedFilters.eventFilter || null"
              [isMulti]="true"
              (selectedEventList)="updateEvents($event)">
            </app-pd-event-select>
          </div>
        </ng-container>

        <ng-container
          *ngIf="
            reportName === 'credits_earned' ||
            reportName === 'pd_session_summary'
          ">
          <div class="form-group mt-3">
            <h5>Event Type:</h5>
            <ng-select
              #typeSelect
              id="type-select"
              (change)="handleTypeSelect($event)"
              placeholder="Select a type..."
              aria-label="pd-type-select">
              <ng-option value="Workshop">Workshop</ng-option>
              <ng-option value="Webinar">Webinar</ng-option>
            </ng-select>
          </div>
          <div class="form-group mt-3">
            <ng-container *ngFor="let type of editedFilters.typesFilter">
              <span
                class="badge badge-item removable"
                (click)="removeType(type)"
                >{{ type }} &nbsp;<i class="bi bi-x"></i> </span
              >&nbsp;
            </ng-container>
          </div>
        </ng-container>

        <ng-container
          *ngIf="
            reportName == 'pd_session_summary' ||
            reportName === 'proforms_reports'
          ">
          <div class="form-group mt-3">
            <h5>Facilitators</h5>
            <app-user-select
              [clearAfterSelection]="true"
              [districtIds]="districtsComponentValue"
              (selectedUser)="addFacilitator($event)"></app-user-select>
          </div>
          <div class="form-group mt-3">
            <ng-container *ngFor="let facilitator of currentFacilitators">
              <div class="d-flex align-items-center col-6 my-1">
                <app-avatar
                  [profile]="facilitator.profile"
                  [avatarSize]="'small'"></app-avatar>
                <span class="ms-2">
                  {{ facilitator.profile.first_name }}
                  {{ facilitator.profile.last_name }}
                </span>
                <button
                  (click)="removeFacilitator(facilitator)"
                  aria-label="Remove facilitator button"
                  class="btn btn-delete btn-sm"
                  type="button"
                  ngbTooltip="Remove Facilitator">
                  <i class="bi bi-x-circle-fill"></i>
                </button>
              </div>
            </ng-container>
          </div>

          <ng-container
            *ngIf="reportName === 'proforms_reports' && !isAnonymous">
            <div class="form-group mt-3">
              <h5>Participant(s)</h5>
              <app-user-select
                [clearAfterSelection]="true"
                (selectedUser)="addParticipant($event)"></app-user-select>
            </div>
            <div class="form-group mt-3">
              <ng-container *ngFor="let participant of currentParticipants">
                <div class="d-flex align-items-center col-6 my-1">
                  <app-avatar
                    [profile]="participant.profile"
                    [avatarSize]="'small'"></app-avatar>
                  <span class="ms-2">
                    {{ participant.profile.first_name }}
                    {{ participant.profile.last_name }}
                  </span>
                  <button
                    (click)="removeParticipant(participant)"
                    aria-label="Remove participant button"
                    class="btn btn-delete btn-sm"
                    type="button"
                    ngbTooltip="Remove Participant">
                    <i class="bi bi-x-circle-fill"></i>
                  </button>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <div
            *ngIf="isAnonymous"
            role="alert"
            class="alert alert-warning text-start mt-4 mb-3">
            Filters that could identify users are not available on anonymous
            forms
          </div>

          <div
            class="form-group mt-3"
            *ngIf="reportName !== 'proforms_reports'">
            <h5>Format</h5>
            <ng-select
              [ngModel]="editedFilters.virtualFilter"
              id="virtual"
              autocomplete="off"
              (change)="handleVirtualSelect($event)"
              [placeholder]="'Select an option'">
              <ng-container *ngFor="let option of virtualOptions">
                <ng-option [value]="option.value">{{ option.label }}</ng-option>
              </ng-container>
            </ng-select>
          </div>

          <div
            class="form-group mt-3"
            *ngIf="reportName !== 'proforms_reports'">
            <h5>Event Status</h5>
            <ng-select
              id="pd_session_status"
              [ngModel]="editedFilters.completedFilter"
              autocomplete="off"
              (change)="handleStatusSelect($event)"
              [placeholder]="'Select an option'">
              <ng-option [value]="1">Completed</ng-option>
              <ng-option [value]="0">Not Completed</ng-option>
            </ng-select>
          </div>
        </ng-container>

        <ng-container
          *ngIf="
            reportName === 'credits_earned' ||
            reportName === 'pd_session_summary'
          ">
          <ng-container *ngIf="settings">
            <div class="form-group mt-3">
              <h5>Category:</h5>
              <ng-select
                #categorySelect
                bindLabel="option"
                (change)="handleCategorySelect($event); categorySelect.blur()"
                id="pd-category-select"
                placeholder="Select a category..."
                aria-label="pd-category-select"
                [groupBy]="'category'"
                [items]="categoryOptions">
              </ng-select>
            </div>

            <div class="form-group mt-3">
              <ng-container
                *ngFor="let categoryOption of currentCategoryOptions">
                <span
                  class="badge badge-item removable"
                  (click)="removeCategory(categoryOption)"
                  >{{ categoryOption.category }}:
                  {{ categoryOption.option }}&nbsp;<i
                    class="bi bi-x"></i> </span
                >&nbsp;
              </ng-container>
            </div>

            <ng-container *ngIf="user?.district">
              <div class="form-group mt-3">
                <h5>Competencies:</h5>
                <app-competency-select
                  #competencySelect
                  [clearAfterSelection]="false"
                  [isMulti]="true"
                  [districtIds]="
                    isE2L ? [] : user && user.district ? [user.district.id] : []
                  "
                  [defaultCompetencies]="
                    editedFilters.competencyList !== undefined
                      ? editedFilters.competencyList
                      : null
                  "
                  (selectedCompetencyList)="
                    editedFilters.competencyList = $event
                  " />
              </div>
            </ng-container>
          </ng-container>
        </ng-container>

        <div *ngIf="reportName === 'evidence_report'" class="form-group mt-3">
          <h5>Attached to Option:</h5>
          <app-has-option-select
            (emittedOption)="updateHasOption($event)"
            [defaultOption]="
              editedFilters.hasOption !== null &&
              editedFilters.hasOption !== undefined
                ? editedFilters.hasOption
                : null
            "></app-has-option-select>
        </div>
        <div *ngIf="reportName === 'evidence_report'" class="form-group mt-3">
          <h5>Reviewed Status:</h5>
          <app-is-reviewed-select
            (emittedOption)="updateIsReviewed($event)"
            [defaultOption]="
              editedFilters.isReviewed !== null &&
              editedFilters.isReviewed !== undefined
                ? editedFilters.isReviewed
                : null
            "></app-is-reviewed-select>
        </div>
      </div>
    </div>
    <div
      *ngIf="
        schoolYearStartTimestamp &&
        schoolYearEndTimestamp &&
        reportName !== 'badge_progress' &&
        reportName !== 'implementationPlan' &&
        !hideDatepicker
      "
      class="datePickerRow unconstrained noTop row">
      <div class="form-group mt-3">
        <h5>Dates:</h5>
        <app-daterange-picker
          [disableTextInput]="true"
          [minDate]="
            reportName !== 'credits_earned' ? schoolYearStartTimestamp : null
          "
          [maxDate]="
            reportName !== 'credits_earned' ? schoolYearEndTimestamp : null
          "
          [fromDate]="
            editedFilters.dateRangeFilter
              ? editedFilters.dateRangeFilter[0]
              : null
          "
          [toDate]="
            editedFilters.dateRangeFilter
              ? editedFilters.dateRangeFilter[1]
              : null
          "
          (selectedFromDate)="updateDateRange('from', $event)"
          (selectedToDate)="
            updateDateRange('to', $event)
          "></app-daterange-picker>
      </div>
    </div>
  </div>
  <div footerContent>
    <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn" (click)="modal.close()">Cancel</button>
      <button
        type="button"
        class="btn btn-primary"
        id="apply-button"
        (click)="applyFilters()">
        Apply
      </button>
    </div>
  </div>
</app-modal>
